import React, { useState, useEffect } from 'react'
import { loadStripe } from '@stripe/stripe-js'
import { PaymentRequestButtonElement, ElementsConsumer, Elements } from '@stripe/react-stripe-js'
import { openStripeAppleOrder, stripeAppleCallBack, billingPlaceOrder, billingCheckout } from '../../../../../api'
import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'
import getPublicKey from '../../../../utils/get-public-key'


const CheckoutForm = props => {
    const { stripe, onError, country, orderTotal, payMethod, inputOrder, shoudBilling, onRenderError, clickHandle, isFastPayment, check } = props
    const [paymentRequest, setPaymentRequest] = useState(null)
    const [error, setError] = useState(false)

    const handleRenderError = e => {
        setError(true)
        onRenderError?.()
    }

    const callBackToBackend = async data => {
        const response = await stripeAppleCallBack(data)
        if (response?.code === 200 && response?.result) {
            const { transactionId } = response?.result
            window.location.href = `/order-confirm/${transactionId}?transactionId=${transactionId}`
        }else{
            onError({
                message: response?.result || 'Network Error',
                orderId: data?.orderId
            })
        }
    }


    useEffect(() => {
        try {
            if (stripe && orderTotal) {

                const pr = stripe.paymentRequest({
                    country,
                    currency: orderTotal.currency?.toLowerCase(),
                    total: {
                        label: 'Order total',
                        amount: orderTotal.currency !== 'JPY' ? Math.round(Number(orderTotal.amount) * 100) : orderTotal.amount,
                    },
                    requestPayerName: true,
                    requestPayerEmail: true,
                })


                pr.on('paymentmethod', async (ev) => {

                    try {
                        clickHandle?.()
                        if(check){
                            if(!check()){
                                return false
                            }
                        }
                    } catch (error) {
                        
                    }

                    let orderResponse
                    if(inputOrder){
                        orderResponse = {
                            result: inputOrder,
                            code: 200
                        }
                    }else{

                        if(shoudBilling){
                            await billingCheckout()
                        }

                        orderResponse = await billingPlaceOrder(isFastPayment)
                    }


                    if (orderResponse?.code === 200 && orderResponse?.result) {

                        const order = orderResponse?.result

                        const appleResponse = await openStripeAppleOrder({ payMethod, orderId: order.id })

                        if (appleResponse?.code === 200 && appleResponse?.result) {
                            // initedOrder
                            const initedOrder = appleResponse?.result

                            // Confirm the PaymentIntent without handling potential next actions (yet).
                            const { paymentIntent, error: confirmError } = await stripe.confirmCardPayment(
                                initedOrder.clientSecret,
                                { payment_method: ev.paymentMethod?.id },
                                { handleActions: false }
                            )

                            if (confirmError) {
                                ev.complete('fail')
                                onError({
                                    message: `${JSON.stringify(confirmError)}`,
                                    orderId: order.id
                                })
                            } else {
                                ev.complete('success')
                                if (paymentIntent.status === "requires_action") {
                                    // Let Stripe.js handle the rest of the payment flow.
                                    const { error } = await stripe.confirmCardPayment(initedOrder.clientSecret)
                                    if (error) {
                                        // The payment failed -- ask your customer for a new payment method.
                                        onError({
                                            message: `${JSON.stringify(error)}`,
                                            orderId: order.id
                                        })
                                    } else {
                                        callBackToBackend({
                                            orderId: initedOrder.orderId,
                                            pid: initedOrder.pid,
                                            payMethod
                                        })
                                    }
                                } else {
                                    callBackToBackend({
                                        orderId: initedOrder.orderId,
                                        pid: initedOrder.pid,
                                        payMethod
                                    })
                                }
                            }
                        }
                    } else {
                        onError({
                            message: orderResponse?.result || 'Network Error',
                            code: orderResponse?.code
                        })
                    }

                })

                // Check the availability of the Payment Request API.
                pr.canMakePayment().then(result => {
                    if (result) {
                        setPaymentRequest(pr)
                    }else{
                        handleRenderError()
                    }
                }).catch(e => {
                    handleRenderError()
                })
            }
        } catch (e) {
            handleRenderError()
            console.error(e)
        }

    }, [stripe, JSON.stringify(orderTotal), country])

    if (paymentRequest) {
        return <PaymentRequestButtonElement options={{ paymentRequest }} />
    }

    return <span>
        {
            error && <FormattedMessage id="select_anthoer_paymentmethod" defaultMessage="Please Select Another PaymentMethod" />
        }
    </span>
}


const InjectedCheckoutForm = props => (
    <ElementsConsumer>
        {({ stripe, elements }) => (
            <CheckoutForm stripe={stripe} elements={elements} {...props} />
        )}
    </ElementsConsumer>
)


const InjectCredit = props => {
    const { payMethod } = props
    const global = useSelector(state => state.global)
    const { config } = global
    const promise = loadStripe(getPublicKey(config?.paykeys?.stripe?.publicKey, payMethod))
    return (
        <Elements style={{ "width": 150, height: 47 }} stripe={promise}>
            <InjectedCheckoutForm {...props} />
        </Elements>
    )
}

export default InjectCredit